import { render, staticRenderFns } from "./jackpot.vue?vue&type=template&id=0a2f41db"
import script from "./jackpot.vue?vue&type=script&lang=js"
export * from "./jackpot.vue?vue&type=script&lang=js"
import style0 from "./jackpot.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/jackpots/jackpot/jackpot.vue
// module id = M5n9
// module chunks = 0